<template>
	<div class="first_screen" id="home">
		<div class="bg_gradient" style="">
		</div>
		<div class="first_screen__body">
			<div style="position:  relative; top: 0; left: 0; ">
				<h2 style="font-size: 1.1em;text-align: center;
					text-shadow: 0 0 20px black;
				">
					Dolphin Planet
				</h2>
				<div class="line_style" >
				</div>
				<h6 style="
					padding-top:  0.4em;
					font-size: 0.4em;
					font-family: 'Involve';
					letter-spacing: 0.5em !important;
					text-shadow: 0 0 20px black;

				">
					HOTEL & SPA
				</h6>
				<div class="first_screen__action_button_box">
					<b-button id="first_screen__action_button" v-scroll-to="'#booking_box'" size="lg">ЗАБРОНИРОВАТЬ</b-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: "FirstScreenComponent",
	components: {},
	methods: {

	},
}
</script>

<style>
	h6, h2 {
		margin-bottom:  0 !important;
	}
	.bg_gradient  {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 50%;
		background: linear-gradient(360deg, #161616 3.59%, rgba(22, 22, 22, 0.8) 45.77%, rgba(22, 22, 22, 0) 96.3%);

	}
	.first_screen {
		background-color: #161616;
		min-height: 100vh;
		width: 100%;
		position: relative;
		/*background-image: url('../assets/img/aparts2/modulnye-domiki-cinema-capsule/cinema_capsule_outdor/hr-161-iz-166.jpg');*/
		background-image: url('../assets/img/first_bg.jpg');
		/*background-image: url('../assets/img/nick_alx__in_the_courtyard_of_a_CAPSULE_hotel_rounded_capsules__88cf672f-4531-4172-8507-cdfca98d0a5b 1.jpg');*/
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center 60px;

	}

	#first_screen__action_button {
		margin-top: 2em;
		padding: 1em 2em !important;
		background-color: #9CCCD4;
		border-radius: 8px;
		color: #1E1E1C;
		letter-spacing: 0.15em;
	}

	.first_screen__body {
		position: relative;
		display: flex;
		min-height: 100vh;
		width: 100%;
		justify-content: center;
		align-content: center;
		align-items: center;
		flex-direction: column;
		flex-wrap: nowrap;
		font-family: 'Involve';
		font-style: normal;
		font-weight: 300;
		font-size: 60px;
		text-align: center;
		color: #FFFFFF;

	}
	.line_style {
		height: 1px;
		border-bottom: 1px solid #A6CBD3;
		width: 100%;
	}


	@media (max-width: 575px) {
		.first_screen {
			background-image: url('../assets/img/first_bg_mobile.jpg');
			/* background-position: 60% center; */
			height: 100vh;
			background-position: center center;
			width: 100%;
		}
		.first_screen__body {
			height: 100%;
			display: flex;
			justify-content: flex-end;
			flex-direction: column;
			flex-wrap: nowrap;
			padding-bottom: 0.5em;
		}
		.line_style {
			height: 1px;
			border-bottom: 1px solid #A6CBD3;
			width: 80%;
			margin: 0 auto;
		}
		.first_screen__action_button_box {
			padding-top: 2em;
		}
		#first_screen__action_button {
			margin-top: 2em;
			padding: 1em 2em !important;
			background-color: transparent;
			border: 1px solid  #A6CBD3;
			border-radius: 8px;
			color: #A6CBD3;
			letter-spacing: 0.2em;
		}
	}

</style>